// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"bf3f4fe4","718":"06404c95","923":"6aca6ef9"}[chunkId] + ".chunk.js";
};